"use client"

import { useState } from "react"
import api from "../../utils/api"
import toast from "react-hot-toast"
import { Upload, LinkIcon } from "lucide-react"

const VideoUpload = () => {
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    video_url: "",
    video_type: "youtube",
  })
  const [loading, setLoading] = useState(false)

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoading(true)

    try {
      await api.post("/videos/upload", formData)
      toast.success("Video uploaded successfully!")
      setFormData({
        title: "",
        description: "",
        video_url: "",
        video_type: "youtube",
      })
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to upload video")
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <h3 className="text-lg font-medium text-gray-900 mb-4">Upload Video</h3>

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label htmlFor="title" className="block text-sm font-medium text-gray-700">
            Video Title
          </label>
          <input
            type="text"
            name="title"
            id="title"
            required
            value={formData.title}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter video title"
          />
        </div>

        <div>
          <label htmlFor="description" className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            name="description"
            id="description"
            rows={4}
            required
            value={formData.description}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            placeholder="Enter video description"
          />
        </div>

        <div>
          <label htmlFor="video_type" className="block text-sm font-medium text-gray-700">
            Video Type
          </label>
          <select
            name="video_type"
            id="video_type"
            value={formData.video_type}
            onChange={handleChange}
            className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="youtube">YouTube</option>
            <option value="file">Direct File</option>
          </select>
        </div>

        <div>
          <label htmlFor="video_url" className="block text-sm font-medium text-gray-700">
            {formData.video_type === "youtube" ? "YouTube URL" : "Video File URL"}
          </label>
          <div className="mt-1 relative rounded-md shadow-sm">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <LinkIcon className="h-5 w-5 text-gray-400" />
            </div>
            <input
              type="url"
              name="video_url"
              id="video_url"
              required
              value={formData.video_url}
              onChange={handleChange}
              className="block w-full pl-10 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              placeholder={
                formData.video_type === "youtube"
                  ? "https://www.youtube.com/watch?v=..."
                  : "https://example.com/video.mp4"
              }
            />
          </div>
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            disabled={loading}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
          >
            <Upload className="mr-2 h-4 w-4" />
            {loading ? "Uploading..." : "Upload Video"}
          </button>
        </div>
      </form>
    </div>
  )
}

export default VideoUpload
